<!--
 * @Descripttion: 代理商下拉选择组件
 * @version: 
 * @Author: Hush
 * @Date: 2020-04-15 16:15:59
-->
<template>
  <el-select 
    v-model="ids" ref="selecter" v-selectLoadMore="scrollLoadMore" 
    :multiple="multiple" filterable remote reserve-keyword :collapse-tags="collapse" :remote-method="remote" 
    @change="handleChange" :disabled="disabled"
    :placeholder="placeholder" class="customerSelect" clearable :popper-append-to-body="appendBody"
    @clear="clearInput"
  >
    <el-option v-for="item in lists" :label="item.name" :value="item['jobNo']" :key="item['jobNo']">
      <!-- <span style="float: left">{{item.name+'('+item.jobNo+')'}}</span> -->
      <!-- <li class="atb-flex atb-flex-justify-between">
        
      </li> -->
      <el-tooltip class='item' effect='dark' :content="item.name" placement="left">
        <span class="name atb-ellipsis" style="float:left">{{item.name + '('+item.jobNo+')'}}</span>
      </el-tooltip>
      <el-tooltip class='item' effect='dark' :content="item.department || ''" placement="right">
        <span class="darp atb-ellipsis" style="float:right;color: #8492a6; font-size: 13px;">{{item.department || ''}}</span>
      </el-tooltip>
    </el-option>
  </el-select>  
</template>
<script>
export default {
  name: 'CustomerSelect',
  props: {
    // 选中的值
    value: {
      type: Array,
    },
    jobNo:{
      typeof: String,
      default:''
    },
     name:{
      typeof: String,
      default:'',
    },
    url:{
      typeof: String,
      default: "",
    },
    // 参数特殊处理
    paramsReset:{
      type: Function,
      default: null
    },
    // 数据特殊处理
    formatData:{
      type: Function,
      default: null
    },
      //数据加载方法
    ajaxMethod: {
      type: String,
      default: 'post'
    },
    multiple: {
      type: Boolean,
      default: false
    },
    collapse: {
      type: Boolean,
      default: false
    },
    initData:{
      type: Array,
      default:null
    },
    placeholder: {
      type: String,
      default:'请输入关键字'
    },
    disabled:{
      type:Boolean,
      default: false
    },
    appendBody:{
      type:Boolean,
      default: true
    }
  },
  data() {
    return {
      ids: "",
      lists: [],   //要渲染的数组
      currentPage: 1,       // 当前页
      pageSize: 20,         // 每页显示多少 
      query: '',       //查询关键字
      currentOption: {}, // 当前选择的选项
      queryIndex: 0,
      totalCount: 0,
      isResetQuery: false,
      isFinished: false,
    }
  },
  watch: {
    value: {
      handler: function(newVal) {
        this.ids = newVal;
      },
      immediate: true
    },
    jobNo: {
      handler: function() {
        this.findUserInLocalList()
        this.$emit('selecterData', this.lists);
      },
      immediate: true
    },
  },
  methods: {
    handleChange(value="") {
      // 存储当前选择的选项
      let selectedItem = this.lists.find(v => v.jobNo == value);
      if (selectedItem) {
        this.currentOption = selectedItem;
      }

      this.$emit('input', value);
      this.$emit('change', value);
    },
    clearInput() {
      this.query = '';
      this.currentPage = 1;
      this.queryIndex = 0;
      this.totalCount = 0;
      this.isResetQuery = true;
    },
    remote(query) {
      let self = this;
      if(!this.url){
        // self.url=this.$api.sys.userInfo.downList;
        self.url = this.$api.sys.userInfo.getUserFilter;
      }
      // 如果换了关键字，重置到第一页
      query = query || '';
      let isSameQuery = query && query === this.query; // 是否是相同关键词的查询，防止用户操作过快时，未来得及重置分页，导致被后面页数的数据覆盖
      if(query !== this.query) {
        self.currentPage = 1;
        self.queryIndex = 0;
        self.totalCount = 0;
        self.isResetQuery = true;
      }
      let skipCount = self.queryIndex || (self.currentPage-1)*self.pageSize;
      if (skipCount < 0) skipCount = 0;
      let queryParam = this.paramsReset && this.paramsReset(query, self.currentPage, self.pageSize) || Object.assign({}, {filter: query, SkipCount: skipCount, MaxResultCount: self.pageSize, userSourceType:[3]});
      self.query = query;
      this.$ajax[this.ajaxMethod](self.url, queryParam,{noLoading:true}).then(res => {
        const resArr= this.formatData && this.formatData(res) || res.items;
        this.isFinished = resArr.length === 0
        if (isSameQuery) {
          const lisMap = {};
          self.lists.forEach(item => {
            lisMap[item.jobNo] = item;
          })
          resArr.forEach(t => {
            if(!lisMap[t.jobNo]){
              self.lists.push(t);
              lisMap[t.jobNo] = t;
            }
          });
        } else {
          const initData = JSON.parse(JSON.stringify(this.initData || []));
          self.lists = initData;
          const lisMap = {};
          self.lists.forEach(item => {
            lisMap[item.jobNo] = item;
          })
          resArr.forEach(t => {
            if(!lisMap[t.jobNo]){
              self.lists.push(t);
            } else {
              lisMap[t.jobNo].department = t.department;
            }
          });
        }
        self.$emit('selecterData', self.lists.concat([this.currentOption]));
        self.queryIndex = res.endIndex
        self.totalCount = res.totalCount;
      });
    },
    scrollLoadMore() {
      this.isResetQuery = false;
      
      let self = this;
      if (self.isFinished) return;
      if(!this.url){
        // self.url=this.$api.sys.userInfo.downList;
        self.url=this.$api.sys.userInfo.getUserFilter;
      }
      self.currentPage += 1;
      let skipCount = self.queryIndex || (self.currentPage - 1) * self.pageSize;
      if (skipCount < 0) skipCount = 0;
      let queryParam = this.paramsReset && this.paramsReset(self.query,self.currentPage,self.pageSize) || Object.assign({}, {filter: self.query, SkipCount: skipCount, MaxResultCount: self.pageSize,userSourceType:[3]});
      this.$ajax[this.ajaxMethod](self.url,queryParam, { noLoading: true }).then(res => {
        const resArr= this.formatData && this.formatData(res) || res.items&&res.items;
        this.isFinished = resArr.length === 0
        const lisMap = {};
        self.lists.forEach(item => {
          lisMap[item.jobNo] = item;
        })
        resArr.forEach(t => {
          if(!lisMap[t.jobNo]){
            self.lists.push(t);
          } else {
            lisMap[t.jobNo].department = t.department;
          }
        });
        self.$emit('selecterData', self.lists.concat([this.currentOption]));
        self.queryIndex = res.endIndex
      })      
    },   
    findUserInLocalList(){
      if(!this.lists.find(v=>v.jobNo == this.jobNo)&&this.jobNo){
        this.lists.unshift({
          jobNo:this.jobNo, name:this.name
        })
      }
    } 
  },  
  created() {
    if (this.jobNo && this.name) {
      this.currentOption = { jobNo: this.jobNo, name: this.name };
    }
    let self = this;
    // 获取数据
    self.remote();
  }    
}
</script>
<style lang="scss">
  .customerSelect{
    .el-select__tags{
      max-width: inherit !important;
      .el-select__input{
        margin-left: 15px;
      }
    }
    .el-select__tags-text{
      max-width: 125px;
      float: left;      
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;  
    }
  }
  .el-select-dropdown{
    .inline-black{
      padding: 0 10px;
    }
    .name{
      max-width: 140px;
    }
    .darp{
      margin-left: 10px;
      max-width: 160px;
    }
  }
</style>